module.exports = __webpack_public_path__ + "img/scene-2.349ac9bd.png";